module.exports = __webpack_public_path__ + "static/9-d1cf7e8c642667d24b1ef0ea5cdb9ef7.jpeg";